import * as React from 'react';
import {connect} from "react-redux";
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {
    COMMON_FORM_STAGE,
    CREATE_FORM_STAGE,
    FLOW_STATUS,
    FORM_TYPE,
    formsCanUpdatePolicy,
    redirectForms,
    UPDATE_FORM_STAGE,
    VERIFY_FORM_STAGE
} from '../../Config/appConfig';
import authState from '../../ReduxRequests/State/authState';

const btnSpinner = require('../../resource/img/button-loading.gif');

interface CommonFormActionButtonsProps {
    formType: string,
    stage: string,
    flowStatus: string,
    changeStage: (stage: string) => void,
    clickSubmit: (e: React.MouseEvent<HTMLElement>) => void,
    clickConfirm: (e: React.MouseEvent<HTMLElement>) => void,
    clickUpdate: (e: React.MouseEvent<HTMLElement>) => void,
    clickProceed: (e: React.MouseEvent<HTMLElement>) => void,
    clickApprove: (e: React.MouseEvent<HTMLElement>) => void,
    clickApproveAndIssue: (e: React.MouseEvent<HTMLElement>) => void,
    clickVoid: (e: React.MouseEvent<HTMLElement>) => void,
    clickPrint: (e: React.MouseEvent<HTMLElement>) => void,
    clickClose: (e: React.MouseEvent<HTMLElement>) => void,
    redirect: (update: boolean) => void,
    loading: boolean,
    isInsurer: () => boolean
}

interface CommonFormActionButtonsState {
    convertToPolicy: boolean
}

class CommonFormActionButtons extends React.Component <RouteComponentProps & CommonFormActionButtonsProps, CommonFormActionButtonsState> {
    public constructor(props: CommonFormActionButtonsProps) {
        super(props);
        this.state = {
            convertToPolicy: false
        };
        this.clickApproveAndIssue = this.clickApproveAndIssue.bind(this);
    }

    public clickApproveAndIssue(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        this.setState({
            convertToPolicy: true
        });
        this.props.clickApproveAndIssue(event);
    }

    public render() {
        switch (this.props.stage) {
            case CREATE_FORM_STAGE.CREATE:
            case VERIFY_FORM_STAGE.CONVERT_TO_POLICY:
                return (
                    <div className="cmBtnsContainer">
                        <div className="cmBtnWrapper">
                            <button className="cmBtn cmGreyBtn cmBoldText" onClick={(e) => this.props.clickClose(e)}
                                    disabled={this.props.loading}>Cancel
                            </button>
                        </div>
                        <div className="cmBtnWrapper">
                            <button className="cmBtn cmBlueBtn cmBoldText" onClick={(e) => this.props.clickSubmit(e)}
                                    disabled={this.props.loading}>Submit
                            </button>
                        </div>
                    </div>
                );
            case CREATE_FORM_STAGE.CONFIRM_CREATE:
            case UPDATE_FORM_STAGE.CONFIRM_UPDATE:
            case UPDATE_FORM_STAGE.CONFIRM_VOID:
                let stage = redirectForms.indexOf(this.props.formType) !== -1 ? CREATE_FORM_STAGE.CREATE : UPDATE_FORM_STAGE.UPDATE;
                if (this.props.formType === FORM_TYPE.IN_VIEW_COVER_NOTE) {
                    stage = this.props.flowStatus === FLOW_STATUS.CONFIRMED ? VERIFY_FORM_STAGE.ISSUE_POLICY : VERIFY_FORM_STAGE.APPROVE_CN;
                }
                return (
                    <div className="cmBtnsContainer">
                        <div className="cmBtnWrapper">
                            <button className="cmBtn cmGreyBtn cmBoldText"
                                    onClick={(e) => this.props.changeStage(stage)}
                                    disabled={this.props.loading}>Back
                            </button>
                        </div>
                        <div className="cmBtnWrapper">
                            <button className="cmBtn cmBlueBtn cmBoldText" onClick={(e) => this.props.clickConfirm(e)}
                                    disabled={this.props.loading}>
                                <span className="cmBtnText">Confirm</span>
                                {this.props.loading && <img className="cmBtnSpinner" src={btnSpinner}/>}
                            </button>
                        </div>
                    </div>
                );
            case CREATE_FORM_STAGE.CREATE_CN_SUMMARY:
            case CREATE_FORM_STAGE.CREATE_PY_SUMMARY:
            case VERIFY_FORM_STAGE.ISSUE_POLICY:
            case UPDATE_FORM_STAGE.UPDATE_SUMMARY:
                const formType = formsCanUpdatePolicy.indexOf(this.props.formType) !== -1 || this.props.formType === FORM_TYPE.VOID ? FORM_TYPE.UPDATE_POLICY : FORM_TYPE.UPDATE_COVER_NOTE;
                if (this.props.isInsurer() && (this.props.formType === FORM_TYPE.IN_VIEW_COVER_NOTE || this.props.formType === FORM_TYPE.UPDATE_COVER_NOTE)) {
                    return (
                        <div className="cmBtnsContainer">
                            <div className="cmBtnWrapper">
                                <button className="cmBtn cmGreyBtn cmBoldText" onClick={(e) => this.props.clickVoid(e)}
                                        disabled={this.props.loading}>Void
                                </button>
                            </div>
                            <div className="cmBtnWrapper">
                                <button className="cmBtn cmGreenBtn cmBoldText"
                                        onClick={(e) => this.props.clickUpdate(e)}
                                        disabled={this.props.loading}>
                                    Update
                                </button>
                            </div>
                            <div className="cmBtnWrapper">
                                <button className="cmBtn cmBlueBtn cmBoldText"
                                        onClick={(e) => this.props.redirect(FORM_TYPE.IN_CONVERT_TO_POLICY, VERIFY_FORM_STAGE.CONVERT_TO_POLICY)}
                                        disabled={this.props.loading}>
                                    Issue Policy
                                </button>
                            </div>
                        </div>
                    );
                }
                else {
                    return (
                        <div className="cmBtnsContainer">
                            <div className="cmBtnWrapper">
                                <button className="cmBtn cmGreyBtn cmBoldText"
                                        onClick={(e) => redirectForms.indexOf(this.props.formType) !== -1 ? this.props.redirect(formType, UPDATE_FORM_STAGE.UPDATE) : this.props.clickUpdate(e)}
                                        disabled={this.props.loading}>
                                    Update
                                </button>
                            </div>
                            <div className="cmBtnWrapper">
                                <button className="cmBtn cmBlueBtn cmBoldText" onClick={(e) => this.props.clickPrint(e)}
                                        disabled={this.props.loading}>
                                    Print
                                </button>
                            </div>
                        </div>
                    );
                }
            case UPDATE_FORM_STAGE.UPDATE:
                return (
                    <div className="cmBtnsContainer">
                        <div className="cmBtnWrapper">
                            <button className="cmBtn cmGreyBtn cmBoldText" onClick={(e) => this.props.clickVoid(e)}
                                    disabled={this.props.loading}>Void
                            </button>
                        </div>
                        <div className="cmBtnWrapper">
                            <button className="cmBtn cmBlueBtn cmBoldText" onClick={(e) => this.props.clickUpdate(e)}
                                    disabled={this.props.loading}>
                                Update
                            </button>
                        </div>
                    </div>
                );
            case COMMON_FORM_STAGE.PROCEED:
                return (
                    <div className="cmBtnsContainer">
                        <div className="cmBtnWrapper">
                            <button className="cmBtn cmGreyBtn cmBoldText" onClick={(e) => this.props.clickClose(e)}
                                    disabled={this.props.loading}>Cancel
                            </button>
                        </div>
                        <div className="cmBtnWrapper">
                            <button className="cmBtn cmBlueBtn cmBoldText" onClick={(e) => this.props.clickProceed(e)}
                                    disabled={this.props.loading}>
                                <span className="cmBtnText">Edit</span>
                                {this.props.loading &&
                                <img className="cmBtnSpinner" src={btnSpinner}/>}
                            </button>
                        </div>
                    </div>
                );
            case VERIFY_FORM_STAGE.APPROVE_CN:
                return (
                    <div className="cmBtnsContainer">
                        <div className="cmBtnWrapper">
                            <button className="cmBtn cmGreyBtn cmBoldText" onClick={(e) => this.props.clickVoid(e)}
                                    disabled={this.props.loading}>Void
                            </button>
                        </div>
                        <div className="cmBtnWrapper">
                            <button className="cmBtn cmGreenBtn cmBoldText" onClick={(e) => this.props.clickApprove(e)}
                                    disabled={this.props.loading}>
                                <span className="cmBtnText">Approve</span>
                                {!this.state.convertToPolicy && this.props.loading &&
                                <img className="cmBtnSpinner" src={btnSpinner}/>}
                            </button>
                        </div>
                        <div className="cmBtnWrapper">
                            <button className="cmBtn cmBlueBtn cmBoldText"
                                    onClick={this.clickApproveAndIssue} disabled={this.props.loading}>
                                <span className="cmBtnText">{'Approve & Issue Policy'}</span>
                                {this.state.convertToPolicy && this.props.loading &&
                                <img className="cmBtnSpinner" src={btnSpinner}/>}
                            </button>
                        </div>
                    </div>
                );
            default:
                return (
                    <div className="cmBtnsContainer">
                        <div className="cmBtnWrapper">
                            <button className="cmBtn cmGreyBtn cmBoldText" onClick={(e) => this.props.clickClose(e)}
                                    disabled={this.props.loading}>Back
                            </button>
                        </div>
                        <div className="cmBtnWrapper">
                            <button className="cmBtn cmBlueBtn cmBoldText" onClick={(e) => this.props.clickPrint(e)}
                                    disabled={this.props.loading}>Print
                            </button>
                        </div>
                    </div>
                );
        }
    }
}

export default withRouter(connect(authState, null)(CommonFormActionButtons));



// WEBPACK FOOTER //
// ./src/Components/Form/CommonFormActionButtons.tsx